
import * as actions from '../constants/subSkillConstants';
//import axios from 'axios';
const getToken = () => {
    return JSON.parse(localStorage.getItem("key"));
};
const getUserId = () => {
    return Number(localStorage.getItem("userId"));
};
const headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
    authorization: "",
};
export const fetchSubSkills = () => async (dispatch) => {
	dispatch({ type: actions.FETCH_SUBSKILL_REQUEST });
    let SERVER_URL = process.env.REACT_APP_API_URL;
	try {
		 await fetch(SERVER_URL +`api/group/skill/mapping/set`, {
            method: "GET",
            headers: { ...headers, authorization: `Bearer ${getToken()?.value}` },
          }).then((res) => res.json())
          .then((data) => {
            // console.log(data)
            dispatch({ type: actions.FETCH_SUBSKILL_SUCCESS, payload: data });
          })
		
	} catch (error) {
		dispatch({ type: actions.FETCH_SUBSKILL_FAILED, payload: error.message });
		// console.log(error.message);
	}
};
export const getAllSubSkills = () => async (dispatch) => {
	dispatch({ type: actions.FETCH_SUBSKILL_REQUEST });
    let SERVER_URL = process.env.REACT_APP_API_URL;
	try {
		 await fetch(SERVER_URL +`api/group/skillSet/all`, {
            method: "GET",
            headers: { ...headers, authorization: `Bearer ${getToken()?.value}` },
          }).then((res) => res.json())
          .then((data) => {
            //console.log(data);
            dispatch({ type: actions.GET_SUBSKILL_GROUP, payload: data });
          })
		
	} catch (error) {
		dispatch({ type: actions.FETCH_SUBSKILL_FAILED, payload: error.message });
		// console.log(error.message);
	}
};

export const sortSubSkillsAsc = () => (dispatch, getState) => {
	const { SubSkillReducers } = getState();
	dispatch({ type: actions.SORT_SUBSKILL_ASC, payload: SubSkillReducers.subSkills });
};

export const sortSubSkillsDesc = () => (dispatch, getState) => {
	const { SubSkillReducers } = getState();
	dispatch({ type: actions.SORT_SUBSKILL_DESC, payload: SubSkillReducers.subSkills });
};

export const searchSubSkills = (query) => (dispatch, getState) => {
	// console.log(query);
	const { SubSkillReducers } = getState();
	const searchNameResults =  SubSkillReducers.searchResults.filter((subSkillss) => 
    subSkillss.group_name.toLowerCase().includes(query.toLowerCase())
	);
	dispatch({ type: actions.SEARCH_SUBSKILL, payload: searchNameResults });
};
export const searchSubSkillsDepartment = (query) => (dispatch, getState) => {
	
	const { SubSkillReducers } = getState();

	const searchDepartmentWishResults =  SubSkillReducers.searchResults.filter((el) =>  el.dept_id == query);
	
	dispatch({ type: actions.SEARCH_SUBSKILL_DEPARTMENT, payload: searchDepartmentWishResults });
};